import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {MemberDTO} from '@domain/member/member.dto';
import {MemberApi} from '@domain/member/member.api';
import {HostDTO} from '@domain/host/host.dto';
import {HostUtil} from '@domain/host/host.util';
import {of} from 'rxjs';


export class MemberResolver {

  public static readonly myMemberships: ResolveFn<MemberDTO[] | null> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
    const api = inject(MemberApi);
    return api.getAllForMe();
  };

  public static readonly getHostPreview: ResolveFn<HostDTO | null> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
    const memberId = this.resolveMemberId(route);
    if (!memberId) {
      return of(null);
    }
    const api = inject(MemberApi);
    return api.getHostPreview(memberId);
  };

  private static resolveMemberId(route: ActivatedRouteSnapshot): string | null {
    return route.paramMap.get('memberId') ?? null;
  };

}
